import { InventoryTransactionType } from './inventory-transaction.model';

export enum ProductInventoryTransactionAction {
    Build = 'Build',
    Remove = 'Remove',
    SetCount = 'SetCount',
}

export interface NewInventoryTransactionDialogArgs {
    entityId: string;
    currentQuantity: number;
    type: InventoryTransactionType;
    entityLabel: string;
    entityPartNumber?: string;
    entityImageUrl?: string;
    useProductInventoryActions?: boolean;
    showBomInventoryToggle?: boolean;
    adjustBomInventoryByDefault?: boolean;
    bomInventoryToggleLabel?: string;
    bomInventoryAdjustmentDisabledReason?: string;
}
